import { RefinementList, Menu } from 'react-instantsearch'

type FilterRefinementIconListProps = {
  heading?: string
  attribute: string
  radio?: boolean
}

const classNames = {
  list: 'w-full flex flex-col gap-y-xxxs s:gap-xxs',
  label: 'flex items-center gap-xxs',
  labelText: 'font-normal text-17 s:text-14 hover:text-primary cursor-pointer transition-colors',
  count: 'sr-only',
  showMore: 'mt-s text-12 text-grey-800 hover:text-primary [&:disabled]:hidden',
}

export default function FilterRefinementList({
  heading,
  attribute,
  radio = false,
}: FilterRefinementIconListProps): JSX.Element {
  return (
    <div
      className={`mr-[-1px] mt-[-1px] flex flex-grow flex-col gap-xxs border-l border-r border-t border-border p-m ms:p-s ms-up:w-1/3`}>
      {heading ? <h6 className="mb-xxxs">{heading}</h6> : null}

      {radio ? (
        <Menu attribute={attribute} sortBy={['name:asc']} limit={8} classNames={classNames} />
      ) : (
        <RefinementList
          attribute={attribute}
          operator="and"
          sortBy={['name:asc']}
          limit={8}
          classNames={classNames}
          escapeFacetValues={true}
        />
      )}
    </div>
  )
}
